export const ApiChangeCommentScope = Symbol('ApiChangeCommentScope');
